import { render, staticRenderFns } from "./PricingDetails.vue?vue&type=template&id=7ce23cb6"
var script = {}
import style0 from "./PricingDetails.vue?vue&type=style&index=0&id=7ce23cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports